import { openPopup } from '@/popups';

export function accountChangePassword() {
  const $button = $('.account-change-password-button');
  if(!$button || $button.length === 0) return

  $button.on('click', (e) => {
    e.preventDefault();
    //todo action
    openPopup($('#popup-password-change-success'));
  });
}
